const portalConfig = {
  firestorePath: '/config/customerVisits',
  firestoreRefType: 'doc',
  moduleName: 'portalConfig',
  statePropName: 'config',
  namespaced: true,
  state: {
    config: {},
  },
  getters: {
    getConfigByDepartment: function(state) {
      return function(dept) {
        return state.config[dept] || null;
      };
    },
  },
  mutations: {},
  actions: {},
};

export default portalConfig;
